module.exports = __webpack_public_path__ + "static/media/logofull.e1a7fc0e.png";